/**
 * Глобальная функция уведомлений
 * Устанавливается из NotifyProvider
 */

let notifyFn = null;

export function setNotifier(fn) {
  notifyFn = fn;
}

export function notify(message, options = {}) {
  if (notifyFn) {
    notifyFn(message, options);
  } else {
    // Fallback
    console[options.severity === 'error' ? 'error' : 'log'](message);
  }
}

export const notifySuccess = (msg) => notify(msg, { severity: 'success' });
export const notifyError = (msg) => notify(msg, { severity: 'error' });
export const notifyWarning = (msg) => notify(msg, { severity: 'warning' });
export const notifyInfo = (msg) => notify(msg, { severity: 'info' });
